var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOperationParam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM12 3C15.9052 3 19.2038 5.5155 20.4495 9H3.5505C4.79625 5.5155 8.09475 3 12 3ZM12 13.5C11.1713 13.5 10.5 12.8287 10.5 12C10.5 11.1713 11.1713 10.5 12 10.5C12.8287 10.5 13.5 11.1713 13.5 12C13.5 12.8287 12.8287 13.5 12 13.5ZM3 12C7.09875 12 10.4183 15.9495 10.488 20.8478C6.246 20.121 3 16.4445 3 12ZM13.512 20.8478C13.5818 15.9495 16.9012 12 21 12C21 16.4445 17.754 20.121 13.512 20.8478Z",
    fill: "#151B26"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationParam);
export default ForwardRef;